<template>
  <div v-loading="loading">
    <el-form ref="formModel" :model="formModel" label-width="140px">
      <el-card v-for="(item,index) in formModel.packages" :key="index" shadow="never" class="card-box" header="渠道包">
        <div slot="header" class="clearfix">
          <span>{{ '渠道包' + (index + 1) }}</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="item.isCollapse = !item.isCollapse">{{ item.isCollapse ? '展开' : '收起' }}</el-button>
        </div>
        <div v-show="!item.isCollapse">
          <el-row>
            <el-col :span="12">
              <el-form-item label="账号主ID" prop="advertiser_id">
                <el-input v-model="item.advertiser_id" disabled placeholder="账号主ID" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :rules="{ required: true, message: '渠道标识不能为空', trigger: 'blur',}"
                :prop="'packages.' + index + '.channel_id'"
                label="渠道标识"
              >
                <el-input v-model="item.channel_id" placeholder="渠道标识" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :prop="'packages.' + index + '.package_id'"
                label="广告包ID"
              >
                <el-input v-model="item.package_id" disabled placeholder="广告包ID" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :rules="{ required: true, message: '渠道包名称不能为空', trigger: 'blur',}"
                :prop="'packages.' + index + '.name'"
                label="渠道包名称"
              >
                <el-input v-model="item.name" placeholder="渠道包名称" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeUpdateDialog">取 消</el-button>
      <el-button type="primary" :loading="submit_loading" @click="configUpdateDialog">更新应用分包</el-button>
    </span>
  </div>
</template>
<script>
import ExtendPackageResource from '@/api/tool/extend-package/gdt';
const extendPackageResource = new ExtendPackageResource();

export default {
  props: {
    /** 表单 */
    formModel: {
      type: Object,
      default: () => {
        return {
          packages: [],
        };
      },
    },
  },
  data() {
    return {
      submit_loading: false,
      loading: false,
    };
  },

  methods: {
    /** 处理更新 */
    configUpdateDialog(){
      this.$refs['formModel'].validate((valid) => {
        if (valid) {
          this.submit_loading = true;
          const packages = this.formModel.packages.map(({ id, channel_id, name: channel_name }) => ({ id, channel_id, channel_name }));
          extendPackageResource.batchUpdateExtendPackageApi({ packages }).then((res) => {
            this.$emit('config', res);
          }).catch((err) => {
            this.$message.error(err);
          }).finally(() => {
            this.submit_loading = false;
          });
        } else {
          return false;
        }
      });
    },

    /** 取消更新 */
    closeUpdateDialog(){
      this.$emit('cancel');
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.card-box {
  margin-bottom: 30px;
}
.dialog-footer{
  width: 100%;
  margin-top: 30px;
  text-align: center;
  display: block;
}
</style>
